module.exports = __webpack_public_path__ + "img/main-number3.05640999.png";